<template>
  <div class="c-accordion-section pb-4 w-full">
    <d-motion-transform
      :click="isDescription"
      :open="open"
      adaptive="section"
      auto-close
      @on-open="onClick"
    >
      <template v-slot:head>
        <div :class="classList" class="flex items-center pt-6 pb-2">
          <span class="grow font-heading6" v-html="text"/>
          <c-icon v-if="isDescription" :turn="open" color="medium" icon="chevron-down"/>
        </div>
      </template>
      <template v-slot:body>
        <div v-html="description"/>
      </template>
    </d-motion-transform>
  </div>
</template>

<script>
import CIcon from '@/components/CIcon'
import DMotionTransform from 'dcode/components/DMotionTransform'
import { computed, ref } from 'vue'
import { props } from '@/components/CAccordionSection/props'

export default {
  name: 'CAccordionSection',
  components: {
    CIcon,
    DMotionTransform
  },
  props,
  setup (props) {
    const open = ref(false)
    const isDescription = computed(() => !!props.description)
    const onClick = event => {
      open.value = event.open
    }

    const classList = computed(() => {
      return {
        'cursor-pointer': isDescription.value
      }
    })

    return {
      open,
      isDescription,
      classList,
      onClick
    }
  }
}
</script>

<style lang="scss"></style>
